import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useApp, API } from "../store";
import { Check, X } from "lucide-react";

export function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { clearCart } = useApp();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/checkout/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); clearCart(); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        attempts++;
        if (attempts < 6) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch {
        attempts++;
        if (attempts < 6) setTimeout(poll, 2000);
        else setStatus("error");
      }
    };
    poll();
  }, [sessionId, clearCart]);

  return (
    <main className="pt-32 pb-32 bg-white min-h-screen grid place-items-center" data-testid="checkout-success">
      <div className="text-center max-w-xl px-6">
        {status === "paid" ? (
          <>
            <div className="w-20 h-20 rounded-full bg-sky-500 grid place-items-center mx-auto"><Check size={40} className="text-white" /></div>
            <h1 className="font-serif-display text-5xl md:text-7xl mt-8 text-slate-900">Ride on.</h1>
            <p className="text-slate-600 mt-4">Your order is confirmed. Check your inbox for details.</p>
          </>
        ) : status === "checking" ? (
          <>
            <div className="overline">Processing</div>
            <h1 className="font-serif-display text-4xl md:text-6xl mt-4 text-slate-900">Confirming your payment…</h1>
          </>
        ) : (
          <>
            <div className="w-20 h-20 rounded-full border border-slate-300 grid place-items-center mx-auto"><X size={40} className="text-slate-500" /></div>
            <h1 className="font-serif-display text-5xl mt-8 text-slate-900">Something went wrong.</h1>
            <p className="text-slate-600 mt-4">Please contact support if you've been charged.</p>
          </>
        )}
        <Link to="/" className="btn-ghost mt-10 inline-flex">Back to home</Link>
      </div>
    </main>
  );
}

export function CheckoutCancel() {
  return (
    <main className="pt-32 pb-32 bg-white min-h-screen grid place-items-center" data-testid="checkout-cancel">
      <div className="text-center max-w-xl px-6">
        <h1 className="font-serif-display text-5xl md:text-7xl text-slate-900">Checkout cancelled</h1>
        <p className="text-slate-600 mt-4">Your cart has been saved. Come back whenever you're ready.</p>
        <Link to="/cart" className="btn-primary mt-10 inline-flex">Back to cart</Link>
      </div>
    </main>
  );
}
